
import { Injectable } from '@angular/core';
import { Headers    } from '@angular/http';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Injectable()

export class ValidService{

    constructor(
      private toastr : ToastrService
    ) {}

    /**
     * Permite validar los campos que so requeridos dentro de un formulario
     */
    touched(form: FormGroup)
    {
      for (var element in form.controls) {
        if (form.controls[element].errors) {
          let key = Object.keys(form.controls[element].errors)[0];
          if (key == 'required') {
            form.controls[element].markAsTouched();
          }
        }
      }
    }// .touched(form: FormGroup)

    /**
     * Función que se encarga de mostrar los mensajes de error de validación
     * JMM-2018-05-29
     */
    fail(data:any[], message: string )
    {
      if (message == "Error en la validación") {
        var temp : string[];
        for (var element in data){
          let key = Object.keys(element);
          this.toastr.error(data[element][0], 'Error', { timeOut: 3000 });
        }
      } else {
        this.toastr.error(message, 'Error', { timeOut: 3000 });
      }
    }// .fail(data:any[], message: string )


    /**
     * Función que se encarga de realizar el arry para los filtros
     * JMM-2018-05-29
     */

    validarStringMultiple(id){
        if(id != null){
              let data = '(';
              for (let i = 0; i < id.length; i++) {
                    data = data + "'"+id[i]+ "'";
                    if(id.length -1 != i){
                          data = data + ',';
                    }
              }
              data = data + ')';
              return data;
        }
    }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/valid.service.ts